export default {
  General: {
    Email: "البريد الإلكتروني",
    Send: "الإرسال",
    Done: "تم",
    Finish: "الإنهاء",
    Try_again: "حاول مرة أخرى",
    or: "أو"
  },
  SamsungType: {
    bixby: "مع Bixby",
    no_bixby: "من دون Bixby",
    home_button: "مع زر الشاشة الرئيسية"
  },
  sendEmail: {
    repair_tip1: "لا يمكن إصلاح هذا النموذج باستخدام تطبيق الجوال. سنرسل لك الحل السطح المكتب عبر البريد الإلكتروني.",
    check_tip1: "لا يمكن إكمال فحص الجهاز باستخدام تطبيق الهاتف المحمول فقط. سنرسل لك الحل المكتبي عبر البريد الإلكتروني.",
    tip1: "لا يمكن إلغاء قفل هذا الطراز باستخدام تطبيق الجهاز المحمول. سنرسل إليك حل سطح المكتب عبر البريد الإلكتروني.",
    tip2: "يُرجى توصيل هاتفك بجهاز الكمبيوتر الخاص بك باستخدام كابل بيانات للحصول على معدل نجاح أفضل.",
    enter_address: "يُرجى إدخال عنوان بريدك الإلكتروني.",
    enter_correct_address: "يرجى إدخال البريد الإلكتروني الصحيح.",
    confidential: "سيتم الحفاظ على سرية عنوان بريدك الإلكتروني التامة.",
    open_link: "افتح {0} على أي متصفح كمبيوتر لتنزيل Dr.Fone.",
    has_sent: "تم إرسال بريدك الإلكتروني",
    almost: "أنت على وشك الانتهاء",
    step1: "الخطوة 1:",
    open_email: "افتح البريد الإلكتروني على جهاز الكمبيوتر واستخدم الرابط الذي أرسلناه إليك لتنزيل إصدار سطح المكتب من Dr.Fone.",
    step2: "الخطوة 2:",
    repair_launch_tip: "شغل Dr.Fone System Repair وقم بتسجيل الدخول إلى حسابك لاستخدام ميزة الإصلاح。",
    check_launch_tip: "ثبّت إصدار Dr.Fone لسطح المكتب وسجّل الدخول باستخدام الحساب نفسه. انقر على \"My Device\"، ثم اتبع التعليمات الظاهرة على الشاشة لتوصيل جهازك. بعد اكتمال الاتصال، انقر على \"Device Detail\" لعرض نتائج الفحص التفصيلية.",
    launch_tip: "قم بتشغيل إلغاء القفل من Dr.Fone وتسجيل الدخول إلى حسابك لاستخدام ميزة إلغاء القفل.",
    contact_us: "اتصل بنا للحصول على المساعدة."
  },
  Unlock: {
    recoveryMode: "إدخال الجهاز في وضع الاسترداد",
    wipe_cache: "مسح قسم ذاكرة التخزين المؤقت على الجهاز",
    wipe_data: "اتبع الإرشادات لمسح البيانات على الجهاز",
    completed: "اكتمل إلغاء القفل",
    completed_tip: "تحقق مما إذا أزال الجهاز قفل الشاشة بنجاح. إذا فشل ذلك، فيُرجى المحاولة مرة أخرى.",
    contact_us: "هل فشل إلغاء القفل؟ اتصل بنا للحصول على مزيد من المساعدة."
  },
  UnlockStep: {
    sa1: "1. قم بإيقاف تشغيل الهاتف وابقِه متصلاً بجهاز الكمبيوتر ",
    sa2: "2. اضغط مع الاستمرار على زر رفع مستوى الصوت وBixby وزر الطاقة في الوقت نفسه",
    sa3: "3. حرر المفاتيح بعد ظهور شعار Samsung وانتظر بضع ثوانٍ",
    sa4: "4. الآن، يُفترض أن يتم تشغيل الجهاز في وضع الاسترداد. اختر \"إعادة تشغيل محمّل نظام التشغيل\" للدخول في وضع التنزيل.",
    sb1: "1. قم بإيقاف تشغيل الهاتف وابقِه متصلاً بجهاز الكمبيوتر",
    sb2: "2. اضغط مع الاستمرار على زرَي الطاقة ورفع مستوى الصوت في الوقت نفسه",
    sb3: "3. واستمر في الضغط على هذين الزرين حتى بعد بدء تشغيل الجهاز النسخ الاحتياطية",
    sb4: "4. الآن، يُفترض أن يتم تشغيل الجهاز في وضع الاسترداد. اختر \"إعادة تشغيل محمّل نظام التشغيل\" للدخول في وضع التنزيل.",
    sc1: "1. قم بإيقاف تشغيل الهاتف وابقِه متصلاً بجهاز الكمبيوتر",
    sc2: "2. اضغط مع الاستمرار على أزرار رفع مستوى الصوت والشاشة الرئيسية والطاقة في الوقت نفسه",
    sc3: "3. حرر المفاتيح بعد ظهور شعار Samsung وانتظر بضع ثوانٍ",
    sc4: "4. الآن، يُفترض أن يتم تشغيل الجهاز في وضع الاسترداد. اختر \"إعادة تشغيل محمّل نظام التشغيل\" للدخول في وضع التنزيل.",
    s5: "5. اضغط على زر مستوى الصوت لتحديد \"مسح البيانات/إعادة التعيين إلى إعدادات المصنع\"، ثم اضغط على زر الطاقة للتأكيد",
    s6: "6. اضغط على زر مستوى الصوت لتحديد \"نعم\"، ثم اضغط على زر الطاقة للتأكيد",
    s7: "7. اضغط على \"مسح قسم ذاكرة التخزين المؤقت\"، ثم حدد \"نعم\"",
    s8: "8. حدد \"إعادة تشغيل النظام الآن\" واضغط على زر الطاقة للتأكيد. ستستغرق إعادة تشغيل الجهاز بعض الوقت.",
    common1: "قم بإيقاف تشغيل الهاتف.",
    common2: "اضغط على مفتاحَي رفع مستوى الصوت والطاقة لبضع ثوانٍ.",
    common3: "حرّر كل المفاتيح عند ظهور وضع الاسترداد على الشاشة.",
    m4: "اختر \"مسح البيانات\" باستخدام مفتاحَي مستوى الصوت وزر الطاقة للقبول.",
    m5: "اختر \"مسح كل البيانات\".",
    m6: "اختر الآن \"التأكيد\" وانتظر ريثما تنتهي العملية.",
    m7: "عُد إلى القائمة الرئيسية باستخدام مفتاح الطاقة.",
    m8: "حدد \"إعادة التشغيل\".",
    m9: "وأخيرًا، اختر \"إعادة تشغيل النظام\".",
    h4: "اختر \"مسح البيانات\" باستخدام مفتاحَي مستوى الصوت وزر الطاقة للقبول.",
    h5: "حدد \"إعادة التعيين إلى إعدادات المصنع\".",
    h6: "اكتب كلمة \"نعم\"، ثم حدد \"إعادة التعيين إلى إعدادات المصنع\".",
    h7: "خلال هذه العملية، ستتم إزالة كل الملفات.",
    h8: "حدد \"العودة\" للعودة إلى القائمة الرئيسية.",
    h9: "وأخيرًا، اختر \"إعادة التشغيل\"."
  }
};
